module.exports = __webpack_public_path__ + "static/media/crocodile(3).cf509ffa.PNG";